<template>
  <div class="mycoupons main selectCoupon">
    <!-- 券包购买 -->
    <div class="cpackage-title" v-if="couponPackageList && couponPackageList.length == 1">本单可用立减<span style="color:#FF4A61">{{couponPackageList[0].package_unit_price}}元</span></div>
    <div class="cpackage-list" v-if="couponPackageList.length > 0">
      <div class="item" v-for="(item, index) in couponPackageList" v-bind:key="index">
        <div style="display: flex">
          <div class="img">
            <div class="c-tit">{{ item.package_coupon_title }}</div>
            <div class="c-price">
              <span>{{ item.package_unit_price }}</span
              >元x<span>{{ item.package_unit_num }}</span
              >张
            </div>
            <div class="c-desc">{{ item.package_coupon_desc }}</div>
          </div>
          <div style="width: 3.2rem">
            <div class="name">{{ item.package_name }}</div>
            <div>{{ item.package_shop_desc }}</div>
            <div class="price">
              ¥<span>{{ item.package_selling_price }}</span>
            </div>
          </div>
        </div>
        <div class="btn-buy" :class="item.package_status === 0 ? 'disabled' : ''" @click="buyCouponPackage(item)">立即购买</div>
      </div>
    </div>
    <div v-if="couponsList.length>0 || unValidCoupons.length>0">
      <ul v-if="couponsList.length>0">
        <li :class="item.coupon_property==4?'package':''" v-for="(item,index) in couponsList" :key="index">
          <span v-if="item.selected == 1" class="selected-icon"></span>
          <div @click="selectCoupon(item)">
            <div class="property">
              {{item.coupon_property_str}}
            </div>
            <p class="coupon-name">
              <span class="coupon-name-tit">{{ item.coupon_name }}</span>
              <span class="coupon-name-pri" v-if="item.coupon_type!=5">
                <span class="money-icon" v-if="item.is_discount == 0">￥ </span>{{ item.amount }}
                <span v-if="item.is_discount == 1">折</span>
              </span>
            </p>
            <p class="expiry-date">
              <span class="fl">{{ item.use_end_time }}</span>
              <span class="fr red fs-20" v-if="item.coupon_type!=5">
                {{item.use_condition }}</span>
            </p>
          </div>
          <!-- <p class="with-top-line" @click="changePackageRule(item)">
            <span class="fl" v-if="item.coupon_property==4">{{ item.package_limit }}</span>
            <span class="fl" v-else>{{ item.description }}</span>
          </p>
          <p class="use-rule" v-if="item.coupon_property==4 && item.showPackageRule" v-html="item.package_rule"></p>
          <p class="cant-use-reason" v-if="item.reduce_message">{{ item.reduce_message }}</p> -->
        </li>
      </ul>
      <div class="splitLine" v-if="unValidCoupons.length>0"><p>不可用优惠券</p></div>
      <ul v-if="unValidCoupons.length>0" class="unavailable-coupon">
        <li :class="item.coupon_property==4?'package':''" v-for="item in unValidCoupons">
          <span v-if="item.selected == 1" class="selected-icon"></span>
          <div>
            <div class="property">
              {{item.coupon_property_str}}
            </div>
            <p class="coupon-name">
              <span class="coupon-name-tit">{{ item.coupon_name }}</span>
              <span class="coupon-name-pri" v-if="item.coupon_type!=5">
                <span class="money-icon" v-if="item.is_discount == 0">￥ </span>{{ item.amount }}
                <span v-if="item.is_discount == 1">折</span>
            </span>
            </p>
            <p class="expiry-date">
              <span class="fl">{{ item.use_end_time }}</span>
              <span class="fr red fs-20" v-if="item.coupon_type!=5">
                {{item.use_condition }}
              </span>
            </p>
          </div>
          <!-- <div class="top-line"><p></p></div>
          <p class="with-top-line">
            <span class="fl" v-if="item.coupon_property==4">{{ item.package_limit }}</span>
            <span class="fl" v-else>{{ item.description }}</span>
          </p> -->
          <p class="cant-use-reason" v-if="item.unable_message">不可用原因：{{ item.unable_message }}</p>
        </li>
      </ul>
      <div class="no-use-btn" @click="donotUseCoupon" v-if="couponsList != null">不使用优惠券</div>
    </div>

    <div class="no-info" v-else>
      <div class="no-goods">
        <img src="../assets/images/empty-01.png"/>
        <p>这笔订单没有可用的优惠券</p>
      </div>
    </div>

  </div>
</template>

<script>
import { actions } from "../store/actions";
export default {
  data() {
    return {
      couponsList: [],
      unValidCoupons: [],
      couponPackageList: [],
      couponType: 1
    }
  },
  computed: {
    schoolInfo() {
      return this.$store.state.schoolInfo;
    }
  },
  created() {
    // document.title = "我的优惠券"
    this.couponType = this.$route.params.type;
    let couponsList = [], unValidCoupons = [];
    if(this.couponType == 1){
      if (window.localStorage.getItem('couponList')) {
        couponsList = JSON.parse(window.localStorage.getItem('couponList'));
        localStorage.removeItem('couponList')
      }
      if (window.localStorage.getItem('unValidCoupons')) {
        unValidCoupons = JSON.parse(window.localStorage.getItem('unValidCoupons'));
        localStorage.removeItem('unValidCoupons')
      }
    }else{
      if (window.localStorage.getItem('deliveryFeeCoupons')) {
        couponsList = JSON.parse(window.localStorage.getItem('deliveryFeeCoupons'));
        localStorage.removeItem('deliveryFeeCoupons')
      }
      if (window.localStorage.getItem('unValidDeliveryFeeCoupons')) {
        unValidCoupons = JSON.parse(window.localStorage.getItem('unValidDeliveryFeeCoupons'));
        localStorage.removeItem('unValidDeliveryFeeCoupons')
      }
    }
    if(couponsList.length){
      for(let v of couponsList){
        // v.showPackageRule = false;
        // if (v.package_rule) {
        //   v.package_rule = v.package_rule.replace(
        //     /(\n|\r|\r\n|↵)/g,
        //     "<br/>"
        //   );
        // }
        let coupon_property = v.coupon_property,
            coupon_property_str = "普通优惠";
          switch (coupon_property) {
            case 1:
              coupon_property_str = "普通优惠";
              break;
            case 2:
              coupon_property_str = "会员福利";
              break;
            case 3:
              coupon_property_str = "单单返现";
              break;
            case 4:
              coupon_property_str = `超值券包x${v.package_num}张`;
              break;
            case 7:
              coupon_property_str = "配送福利";
              break;
          }
          v.coupon_property_str = coupon_property_str;
        }
    }

    if(unValidCoupons.length){
      for(let v of unValidCoupons){
        // v.showPackageRule = false;
        // if (v.package_rule) {
        //   v.package_rule = v.package_rule.replace(
        //     /(\n|\r|\r\n|↵)/g,
        //     "<br/>"
        //   );
        // }
        let coupon_property = v.coupon_property,
            coupon_property_str = "普通优惠";
          switch (coupon_property) {
            case 1:
              coupon_property_str = "普通优惠";
              break;
            case 2:
              coupon_property_str = "会员福利";
              break;
            case 3:
              coupon_property_str = "单单返现";
              break;
            case 4:
              coupon_property_str = `超值券包x${v.package_num}张`;
              break;
            case 7:
              coupon_property_str = "配送福利";
              break;
          }
          v.coupon_property_str = coupon_property_str;
        }
    }
    this.couponsList = couponsList;
    this.unValidCoupons = unValidCoupons;

    // 券包
    if(window.localStorage.getItem('orderPreviewInfo')){
      let orderPreviewInfo = JSON.parse(window.localStorage.getItem('orderPreviewInfo'));
      if(orderPreviewInfo.promotionCouponPackageBeanList && orderPreviewInfo.promotionCouponPackageBeanList.length > 0){
        this.getCouponPackageList();
      }
    }
  },
  methods: {
    selectCoupon: function (item) {
      if (item.is_toast == 1 && item.toast_tips && item.toast_tips.length > 0) {
        this.$messagebox.alert(item.toast_tips, '使用须知').then(action => {
          for (var i = 0; i < this.couponsList.length; i++) {
            if (this.couponsList[i].user_coupon_id == item.user_coupon_id) {
              this.couponsList[i].selected = 1
            } else {
              this.couponsList[i].selected = 0
            }
          }
          var objStr = JSON.stringify(item)
          window.localStorage.setItem('selectedCoupon', objStr)
          window.localStorage.setItem('orderPreviewType', 2)
          window.localStorage.setItem('isSelectedCoupon', true)
          this.$router.push({name: 'OrderSettle'})
        });
      } else {
        for (var i = 0; i < this.couponsList.length; i++) {
          if (this.couponsList[i].user_coupon_id == item.user_coupon_id) {
            this.couponsList[i].selected = 1
          } else {
            this.couponsList[i].selected = 0
          }
        }
        var objStr = JSON.stringify(item)
        if(this.couponType == 1){
          window.localStorage.setItem('selectedCoupon', objStr)
        }else{
          window.localStorage.setItem('selectedDeliveryCoupon', objStr)
        }

        window.localStorage.setItem('orderPreviewType', 2)
        window.localStorage.setItem('isSelectedCoupon', true)
        this.$router.push({name: 'OrderSettle'})
      }

    },
    donotUseCoupon: function () {
      if (this.couponsList) {
        window.localStorage.removeItem(this.couponType == 1 ? 'selectedCoupon' : 'selectedDeliveryCoupon')
        for (var i = 0; i < this.couponsList.length; i++) {
          this.couponsList[i].selected = 0
        }
      }
      this.$router.push({name: 'OrderSettle'})
      window.localStorage.setItem('orderPreviewType', 2)
      window.localStorage.setItem('isSelectedCoupon', true)
    },
    // 获取券包
    getCouponPackageList() {
      let _this = this;
      let params = {
        school_id: _this.schoolInfo.schoolId,
        shop_id: localStorage.getItem('shop_code'),
        source: 2
      };
      actions.postPackageList(_this, params, (data) => {
        if (data && data.length > 0) {
          _this.couponPackageList = data;
          // for (let v of data) {
          //   if (v.package_status === 1) {
          //     if (v.package_rule) {
          //       v.package_rule = v.package_rule.replace(
          //         /(\n|\r|\r\n|↵)/g,
          //         "<br/>"
          //       );
          //     }
          //     _this.couponPackageList.push(v);
          //   }
          // }
          var clickParams = [{
            uid: _this.$store.state.wxUid,
            code: 'asa_order_choose_coupon_bag',
            createTime: new Date().getTime(),
            refId: _this.couponPackageList[0].package_id,
            firstValue: _this.schoolInfo.schoolId,
            // secondValue: _this.shopCode
          }]
          _this.addLog1(clickParams);
        }
      });
    },
    // 购买券包
    buyCouponPackage(item) {
      this.$router.push({name: 'CouponPackage', query: {id: item.package_id}})
      var clickParams = [{
        uid: this.$store.state.wxUid,
        code: 'click_order_choose_coupon_bag',
        createTime: new Date().getTime(),
        refId: item.package_id,
        firstValue: this.schoolInfo.schoolId,
        // secondValue: _this.shopCode
      }]
      this.addLog1(clickParams);
    },
    changePackageRule(item) {
      item.showPackageRule = !item.showPackageRule;
      this.$forceUpdate();
      // for(let v of this.couponsList){
      //   if(v.coupon_id == item.coupon_id){
      //     this.$set(v,'showPackageRule',!item.showPackageRule)
      //   }
      // }
    },
    // 统计埋点
    addLog1(list) {
      var _this = this;
      var params = {
        logDetails: list,
        source: 3
      }
      actions.postLogAdd(_this, params, function (data) {
        // console.log('记录成功');
      }, function (data) {

      })
    }
  }
}
</script>
<style scoped>
.cpackage-list {
  margin: 0.24rem 0.24rem 0 0.24rem;
}
</style>




// WEBPACK FOOTER //
// SelectCoupon.vue?5c92218b